<template>
  
<b-overlay
      :show="loading"
      spinner-variant="primary"
      spinner-type="grow"
      spinner-small
      rounded="sm"
    >

   
  <div>
      <UserForm :user="user" :info="true" v-if="loaded" :readOnly="true" />
      <b-card title="Avoirs">

        <!-- <b-button  v-if="user.customer_stripe_id"  v-b-modal.modal-refund>Créer un remboursement</b-button><br /><br /> -->
        <b-button v-b-modal.modal-credit>Créer un avoir</b-button>

      </b-card>
      <b-card title="Scans">
        <b-row>
          <b-col
          md="12"
          xl="12"
          class="mb-1">
            <div v-if="scans.length==0">
              Aucun scan pour cet utilisateur.
            </div>
            <div v-else>
              <vue-good-table
                mode="remote"
                :total-rows="totalRows"
                :columns="columnsScan"
                :rows="scans"
                :pagination-options="{
                  enabled: true,
                  perPage: pageLength
                }"
              >
                <template
                  slot="table-row"
                  slot-scope="props"
                >
                 

                  <!-- Column: Action -->
                  
                  <span v-if="props.column.field === 'action'">
                    <span>
                      <b-button
                        @click="displayScan(props.row.id)"
                        >
                        Voir le mesh
                        </b-button><br /><br />
                     <b-button
                        :href="props.row.point_cloud_url"
                        >
                        Télécharger PointCloud
                      </b-button>
<br /><br />
                      <b-button
                        :href="props.row.measures_url"
                        >
                        Télécharger Measures
                      </b-button>
<br /><br />
                      <b-button
                        :href="props.row.measure_points_url"
                        >
                        Télécharger MeasurePoints
                      </b-button>
                      <br /><br />
                      <b-button
                        :href="props.row.unprojected_point_cloud_url"
                        >
                        Télécharger Unprojected
                      </b-button>

                      <br /><br />
				<a target="_blank" v-if="props.row.basepoints_url!=null" :href="props.row.basepoints_url" download="true">
				  <b-button
					
					variant="dark"
				  >
					Download Basepoints
				  </b-button>
				</a>
				<br /><br />
				<a target="_blank" v-if="props.row.screenshot0_url!=null" :href="props.row.screenshot0_url" download="true">
				  <b-button
					
					variant="dark"
				  >
					Download screenshot0
				  </b-button>
				</a>
				<br /><br />
				<a target="_blank" v-if="props.row.screenshot1_url!=null" :href="props.row.screenshot1_url" download="true">
				  <b-button
					
					variant="dark"
				  >
					Download screenshot1
				  </b-button>
				</a>
				<br /><br />
				<a target="_blank" v-if="props.row.screenshot2_url!=null" :href="props.row.screenshot2_url" download="true">
				  <b-button
					
					variant="dark"
				  >
					Download screenshot2
				  </b-button>
				</a>
				<br /><br />
				<a target="_blank" v-if="props.row.screenshot3_url!=null" :href="props.row.screenshot3_url" download="true">
				  <b-button
					
					variant="dark"
				  >
					Download screenshot3
				  </b-button>
				</a>
        <b-button
					@click="downloadScanFiles(props.row.id)"
					variant="dark"
				  >
				Download scan files (rawPoints + ColorHistory)
				  </b-button>
<br /><br />

                    

                        
                    </span>
                  </span>
                  <span v-else>
                    {{ props.formattedRow[props.column.field] }}
                  </span>
                </template>
                <template
                  slot="pagination-bottom"
                  slot-scope="props"
                >
                  <div class="d-flex justify-content-between flex-wrap">
                    <div class="d-flex align-items-center mb-0 mt-1">
                      <span class="text-nowrap ">
                        Afficher
                      </span>
                      <b-form-select
                        v-model="pageLength"
                        :options="['5','10','25','50']"
                        class="mx-1"
                        @input="(value)=>props.perPageChanged({currentPerPage:value})"
                      />
                      <span class="text-nowrap"> sur {{ totalRows }} résultats </span>
                    </div>
                    <div>
                      <b-pagination
                        v-model="currentPage"
                        :total-rows="totalRows"
                        :per-page="pageLength"
                        first-number
                        last-number
                        align="right"
                        prev-class="prev-item"
                        next-class="next-item"
                        class="mt-1 mb-0"
                      >
                        <template #prev-text>
                          <feather-icon
                            icon="ChevronLeftIcon"
                            size="18"
                          />
                        </template>
                        <template #next-text>
                          <feather-icon
                            icon="ChevronRightIcon"
                            size="18"
                          />
                        </template>
                      </b-pagination>
                    </div>
                  </div>
                </template>
              </vue-good-table>
              <ScanPopup :scan_id="currentScan" v-if="displayScanPopup" />
            </div>
          </b-col>
        </b-row>
      </b-card>
      <b-card title="Adresses">
        <b-row>
          <b-col
          md="12"
          xl="12"
          class="mb-1">
            <div v-if="addresses.length==0">
              Aucune adresse pour cet utilisateur.
            </div>
            <div v-else>
              <div v-for="address in addresses" :key="address.id">
                <b>{{address.name}}</b><br />
                Nom : {{address.first_name}}<br />
                Prénom : {{address.last_name}}<br />
                Téléphone : {{address.phone}}<br />
                Adresse 1 : {{address.address1}}<br />
                Adresse 2 : {{address.address2}}<br />
                Code postal : {{address.postcode}}<br />
                Ville : {{address.city}}<br />
                Pays : {{address.country}}<br />
                Adresse par défaut : {{address.default_address}}<br /><br />
              </div>
            </div>
          </b-col>
        </b-row>
      </b-card>
      <b-card title="Ordonnances">
        <b-row>
          <b-col
          md="12"
          xl="12"
          class="mb-1">
            <div v-if="prescriptions.length==0">
              Aucune ordonnance pour cet utilisateur.
            </div>
            <div v-else>
              <vue-good-table
                :columns="columnsPrescription"
                :rows="prescriptions"
                :pagination-options="{
                  enabled: false
                }"
              >
                <template
                  slot="table-row"
                  slot-scope="props"
                >
                 
                  <!-- Column: Action -->
                  
                  <span v-if="props.column.field === 'action'">
                    <span>
                     <b-button
                        @click="displayPrescription(props.row.id)"
                        >
                        Voir l'ordonnance
                        </b-button>
                    </span>
                  </span>
                  <span v-else>
                    {{ props.formattedRow[props.column.field] }}
                  </span>
                </template>
               
              </vue-good-table>
              <PrescriptionPopup :prescription_id="currentPrescription" v-if="displayPrescriptionPopup" />
            </div>
          </b-col>
        </b-row>
      </b-card>

      <b-card title="Commandes">
        <b-row>
          <b-col
          md="12"
          xl="12"
          class="mb-1">
            <div v-if="orders.length==0">
              Aucune commande pour cet utilisateur.
            </div>
            <div v-else>
              <vue-good-table
                :columns="columns"
                :rows="orders"
                :pagination-options="{
                  enabled: false
                }"
              >
                <template
                  slot="table-row"
                  slot-scope="props"
                >
                  <span v-if="props.column.field === 'status'">
                    <b-badge v-if="props.row.status=='dispatched'" variant="success">Envoyée</b-badge>
                    <b-badge v-else-if="props.row.status=='scanned'" variant="success">Scans effectués</b-badge>
                    <b-badge v-else-if="props.row.status=='delivered'" variant="success">Livrée</b-badge>
                    <b-badge v-else-if="props.row.status=='printing'" variant="success">En production</b-badge>
                    <b-badge v-else-if="props.row.status=='completed'" variant="warning">Complétée</b-badge>
                    <b-badge v-else-if="props.row.status=='refunded'" variant="warning">Remboursée</b-badge>
                    <b-badge v-else-if="props.row.status=='failed'" variant="danger">échouée</b-badge>
                    <b-badge v-else-if="props.row.status=='canceled'" variant="danger">Annulée</b-badge>
                            
                    <b-badge v-else variant="danger">{{props.row.status}}</b-badge>
                  </span>

                  <!-- Column: Action -->
                  <span v-else-if="props.column.field === 'amount'">
                    {{ props.formattedRow[props.column.field] }}€
                  </span>
                  <span v-else-if="props.column.field === 'action'">
                    <span>
                      <b-dropdown
                        variant="link"
                        toggle-class="text-decoration-none"
                        no-caret
                      >
                        <template v-slot:button-content>
                          <feather-icon
                            icon="MoreVerticalIcon"
                            size="16"
                            class="text-body align-middle mr-25"
                          />
                        </template>
                        <b-dropdown-item  @click="$router.push({name:'orderDetail', params: { id: props.row.id }})">
                          <feather-icon
                            icon="Edit2Icon"
                            class="mr-50"
                          />
                          <span>Voir</span>
                        </b-dropdown-item>
                      
                      </b-dropdown>
                    </span>
                  </span>
                  <span v-else>
                    {{ props.formattedRow[props.column.field] }}
                  </span>
                </template>
               
              </vue-good-table>
            </div>
          </b-col>
        </b-row>
      </b-card>
      <b-modal
        id="modal-credit"
        cancel-variant="outline-secondary"
        cancel-title="Annuler"
        ok-variant="primary"
        ok-title="Créer l'avoir"
        @ok=""
       
        centered
        title="Avoir"
      >
        <b-card-text>
          
          Montant (€) : <b-form-input v-model="creditAmount" type="number" placeholder="Montant" /><br /><br />
          
        </b-card-text>
      </b-modal>
      <b-modal
        id="modal-refund"
        cancel-variant="outline-secondary"
        cancel-title="Annuler"
        ok-variant="primary"
        ok-title="Rembourser"
        @ok="createPromotion()"
       
        centered
        title="Remboursement"
      >
        <b-card-text>
          
          Montant (€) : <b-form-input v-model="refundAmount" type="number" placeholder="Montant" /><br /><br />
        </b-card-text>
      </b-modal>
  </div>
</b-overlay>
</template>

<script>
import {BModal,BOverlay, BButton, VBModal, BCard, BCol, BRow, BCardText, BAvatar, BBadge, BPagination, BFormGroup, BFormInput, BFormSelect, BDropdown, BDropdownItem, } from 'bootstrap-vue'
import {APIRequest, Auth, Woocommerce} from '@simb2s/senseye-sdk'
import ScanPopup from '../../components/ScanPopup.vue'
import { VueGoodTable } from 'vue-good-table'
import UserForm from './UserForm.vue'
import emitter from 'tiny-emitter/instance'
import PrescriptionPopup from '../../components/PrescriptionPopup.vue'
import axios from 'axios'

export default {
  components: {
    BCard,
    BCardText,
    VueGoodTable,
    BAvatar,
    BBadge,
    BOverlay,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BDropdown,
    BDropdownItem,
    BModal,
    BButton, 
    BCol,
    BRow,
    UserForm,
    ScanPopup,
    PrescriptionPopup
  },
  data() {
    return {
      totalRows:0,
      currentOffset:0,
      pageLength: 10,
      currentPage:1,
      creditAmount:0,
      user:null,
      scans:[],
      refundAmount:0,
      prescriptions:[],
      orders:[],
      addresses:[],
      loaded:false,
      loading:true,
      displayScanPopup:false,
      currentScan:null,
      currentPrescription:null,
      displayPrescriptionPopup:false,
      columns: [
        {
          label: 'Date',
          field: 'date',
        },
        {
          label: 'Total',
          field: 'amount',
        },
        {
          label: 'Status',
          field: 'status',
        },
        {
          label: 'Action',
          field: 'action',
        },
      ],
      columnsScan: [
        {
          label: 'Nom',
          field: 'name',
        },
        {
          label: 'Date',
          field: 'date',
        },
        {
          label: 'Appareil',
          field: 'device_model',
        },
        {
          label: 'Scan par défaut',
          field: 'default_scan',
        },
        {
          label: 'Action',
          field: 'action',
        },
      ],
      columnsPrescription: [
        {
          label: 'Nom',
          field: 'name',
        },
        
        {
          label: 'Action',
          field: 'action',
        },
      ],
    }
  },
  watch:{
    currentPage: async function() {
      this.loading = true
      await this.getUserScans()
      this.loading = false
    },
    pageLength: async function() {
      if (this.currentPage !== 1) {
        this.currentPage = 1
        return
      }
      this.loading = true
      await this.getUserScans()
      this.loading = false
    }
  },
  methods:{
    
    async createPromotion() {
      try {
        if (this.creditAmount <= 0) {
          this.$bvToast.toast('Le montant doit être supérieur à 0.', {
            title: 'Erreur',
            variant: 'danger',
            solid: true,
          });
          return;
        }

        const promotionData = {
          user:{id: this.user.id},
          name: `Avoir pour ${this.user.name} ${this.user.surname}`,
          code: `AV-${Math.random().toString(36).substr(2, 9).toUpperCase()}`,
          amount: this.creditAmount,
          active:true,
          type: 'fixed',
          user_limit: 1,
          usage_limit: 1
        };

        let promo=await APIRequest.create('promotions', promotionData);

        this.$bvToast.toast('Avoir créé avec succès.', {
          title: 'Succès',
          variant: 'success',
          solid: true,
        });

        this.$router.push({name:'editPromotion', params: { id: promo.id }})

        this.creditAmount = 0; // Reset the input field
      } catch (error) {
        this.$bvToast.toast('Une erreur est survenue lors de la création de la promotion.', {
          title: 'Erreur',
          variant: 'danger',
          solid: true,
        });
        console.error(error);
      }
    },
    displayPrescription(id) {
      this.currentPrescription=id
      this.displayPrescriptionPopup=true
    },
    displayScan(id)
    {
      this.currentScan = id
      this.displayScanPopup = true
    },
    async downloadScanFiles(scanId) {
      try {
        const response = await axios.get(
          `https://api.sens-eye.fr/api/download-scan-files/${scanId}`,
          {
            responseType: 'blob',
            headers: {
              Authorization: `Bearer ${localStorage.token_senseye_auth}`,
            },
          },
        )

        const contentType = response.headers['content-type'] || ''
        if (contentType.includes('application/json')) {
          const text = await response.data.text()
          const errorBody = JSON.parse(text)
          throw new Error(errorBody.error || 'Download failed')
        }

        const contentDisposition = response.headers['content-disposition']
        let filename = `scan-${scanId}.zip`
        if (contentDisposition) {
          const match = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/)
          if (match && match[1]) {
            filename = match[1].replace(/['"]/g, '')
          }
        }

        const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/zip' }))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', filename)
        document.body.appendChild(link)
        link.click()
        link.remove()
        window.URL.revokeObjectURL(url)
      } catch (error) {
        let message = 'Erreur lors du téléchargement des fichiers du scan.'
        if (error.response && error.response.data instanceof Blob) {
          try {
            const text = await error.response.data.text()
            const errorBody = JSON.parse(text)
            if (errorBody.error) {
              message = errorBody.error
            }
          } catch (e) { /* ignore parse errors */ }
        } else if (error.message) {
          message = error.message
        }
        this.$bvToast.toast(message, {
          title: 'Erreur',
          variant: 'danger',
          solid: true,
        })
        console.error(error)
      }
    },
    async getUserScans() {
      const limit = Number(this.pageLength)
      const offset = (this.currentPage - 1) * limit + 1
      let scans = await APIRequest.list_with_request('scans', '?user='+this.$route.params.id+'&limit='+limit+'&order=desc&offset='+offset)
      this.totalRows = scans[1] && scans[1].total_items != null ? scans[1].total_items : scans[1]
      this.currentOffset = scans[1] && scans[1].offset != null ? scans[1].offset : this.currentOffset
      this.scans = scans[0]
    },
    async getUserAddresses() {
      let addresses = await APIRequest.list('addresses', this.$route.params.id)
      this.addresses = addresses[0]

    },
    async getUserPrescriptions() {
      let prescriptions = await APIRequest.list('prescriptions', this.$route.params.id)
      this.prescriptions = prescriptions[0]

    },
    async getUserOrders() {
      let orders = await APIRequest.list('orders', this.$route.params.id)
      orders=orders[0]
      
      for(let i=0;i<orders.length;i++)
      {
        let item={}
        item=orders[i]
        if(orders[i].woo_order)
        {
      
        let order = await Woocommerce.detail('orders',orders[i].woo_order)
        item.status=order.status
        }
        else
        {
          item.status='non complétée'
        }

        this.orders.push(item)
      }
    }
  },
  async mounted()
  {
    emitter.on('hide-popup-scan', function () {
      this.displayScanPopup=false
    }, this);

    emitter.on('hide-popup-prescription', function () {
      this.displayPrescriptionPopup=false
    }, this);

    this.user=await Auth.get_user_with_id(this.$route.params.id)
    
    await this.getUserScans()
    await this.getUserPrescriptions()
    await this.getUserOrders()
    await this.getUserAddresses()
    this.loaded=true
    this.loading=false
  }
}
</script>
